const CONTENT = ".expandable-cell .short-content";

// The project's TypeScript lib predates ResizeObserver (drawer.ts reaches it through window too).
interface SizeObserver {
  observe(target: Element): void;
}
type SizeObserverCtor = new (callback: (entries: { target: Element }[]) => void) => SizeObserver;

let resizeObserver: SizeObserver | null = null;

function sync(content: HTMLElement): void {
  const icon = content.closest(".expandable-cell")?.querySelector<HTMLElement>(".view-full-data");
  if (!icon || icon.classList.contains("is-always")) return;

  const truncated = icon.hasAttribute("data-cut") || content.scrollWidth > content.clientWidth + 1;
  icon.style.display = truncated ? "inline-block" : "none";
}

function watch(root: Element | Document): void {
  if (!resizeObserver) return;
  if (root instanceof Element && root.matches(CONTENT)) resizeObserver.observe(root);
  root.querySelectorAll<HTMLElement>(CONTENT).forEach((content) => resizeObserver?.observe(content));
}

export function initExpandableCells(): void {
  const Observer = (window as unknown as { ResizeObserver?: SizeObserverCtor }).ResizeObserver;
  if (resizeObserver || !Observer) return;

  // Fires once when observing starts too, so every icon gets its first measurement here.
  resizeObserver = new Observer((entries) => entries.forEach((entry) => sync(entry.target as HTMLElement)));
  watch(document);

  // On <html>, not <body>: a Turbo visit replaces the body, and that swap arrives here as one
  // added node.
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) watch(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
}
